export default (string) => {
  return string.replace(/\D/g, '');
}
